import { RoutineColors } from "@/utilities/routineColors";
import type { Routine } from "instantdb/types";

export const HEART_ROUTINES: Partial<Routine>[] = [
  {
    id: "heart-health-tracking",
    title: "Heart Health Tracking",
    symbol: "🫀",
    description: "Monitor key indicators of heart health",
    dailyRoutine: false,
    selectedDays: [{ day: "monday", datetime: "08:00:00.000Z" }],
    color: RoutineColors[9].value,
    steps: [
      {
        id: "heart-tracking-1",
        title: "Blood pressure check",
        description: "Measure and record your blood pressure",
      },
      {
        id: "heart-tracking-2",
        title: "Heart rate monitoring",
        description: "Check and record your resting heart rate",
      },
      {
        id: "heart-tracking-3",
        title: "Activity review",
        description: "Review your week's physical activity",
      },
      {
        id: "heart-tracking-4",
        title: "Nutrition assessment",
        description: "Note heart-healthy foods consumed",
      },
    ],
  },
  {
    id: "cardiovascular-wellness",
    title: "Cardiovascular Wellness",
    symbol: "🫀",
    description: "Daily habits to support heart health",
    dailyRoutine: true,
    selectedDays: [],
    color: RoutineColors[10].value,
    steps: [
      {
        id: "heart-wellness-1",
        title: "Heart-healthy breakfast",
        description: "Include fiber, healthy fats, and protein",
      },
      {
        id: "heart-wellness-2",
        title: "Movement session",
        description: "Complete at least 20 minutes of activity",
      },
      {
        id: "heart-wellness-3",
        title: "Stress management",
        description: "Practice a technique to reduce stress",
      },
      {
        id: "heart-wellness-4",
        title: "Sodium tracking",
        description: "Monitor sodium intake throughout the day",
      },
    ],
  },
  {
    id: "heart-health-planning",
    title: "Heart Health Planning",
    symbol: "🫀",
    description: "Weekly planning for cardiovascular wellness",
    dailyRoutine: false,
    selectedDays: [{ day: "sunday", datetime: "18:00:00.000Z" }],
    color: RoutineColors[11].value,
    steps: [
      {
        id: "heart-planning-1",
        title: "Meal planning",
        description: "Plan heart-healthy meals for the week",
      },
      {
        id: "heart-planning-2",
        title: "Exercise schedule",
        description: "Schedule cardio and strength sessions",
      },
      {
        id: "heart-planning-3",
        title: "Health metrics review",
        description: "Review blood pressure and heart rate patterns",
      },
      {
        id: "heart-planning-4",
        title: "Set weekly goals",
        description: "Establish specific heart health goals for the week",
      },
    ],
  },
];
